export default (urlParameters) => {
  return {
    footer_ad: true,
    global_user_profile_manager: true,
    storm_center: true,
    storm_track: true
  }
}